const i = {
  large: {
    width: 512,
    imageHeight: 188,
    variantTitle: "heading1",
    variantDescription: "bodyLRegular"
  },
  medium: {
    width: 384,
    imageHeight: 140,
    variantTitle: "heading3",
    variantDescription: "bodyLRegular"
  },
  small: {
    width: 160,
    imageHeight: 24,
    variantTitle: "heading4",
    variantDescription: "bodyMRegular"
  }
};
export {
  i as SIZES_EMPTY_STATE
};
